import { GlobalNav } from "@/patterns/global-nav/src/index.tsx";
import { CollectionsCompoundSubNavProps } from "@/templates/collections/collections-compound-nav-props.tsx";

import { CTA_URL_PATH } from "./urls.ts";

export const StrategyCollectionNavbar = () => {
    return (
        <GlobalNav
            productKey={"home"}
            compoundNav={{
                ...CollectionsCompoundSubNavProps(),
                ctaUrl: CTA_URL_PATH
            }}
        />
    );
};
